export default __webpack_public_path__ + "img/27.8c49722b.jpg";